
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Onedayadventurersortnearnagpur() {



  const cardData =
  {
    keyword: ' One Day Adventure Resorts Near Nagpur',
    heading:  'Woodland Escape: One Day Adventure Resorts Near Nagpur',
    headingDescription: 'Woodland Escape Resort as a Pre Wedding Destination Near Nagpur offers an idyllic backdrop for your photo-shoot and celebration just outside the city, where forested terrain, open meadows and gentle natural light create a picture-perfect setting. Designed for couples seeking both ease of access and a touch of wilderness elegance, the resort blends natural charm with tasteful amenities—think leafy pathways, quiet corners amid tall trees, and scenic lawns ideal for styled photo sessions. Whether you’re planning a fun friends-and-family pre-wedding outing, a romantic sunrise shoot, or a full weekend gathering with rehearsal dinner and brunch, Woodland Escape Resort near Nagpur provides a serene yet stylish venue to capture your love story in a refreshing change of pace.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



 "services": [
    {
      "name": "Pre Wedding Destination Near Nagpur",
      "description": "Woodland Escape Resort is one of the most beautiful pre-wedding destinations near Nagpur, offering a magical blend of nature and elegance. The resort features lush green landscapes, charming gardens, and serene surroundings that make every photograph come alive. Couples can enjoy a private, peaceful shoot experience with multiple scenic spots including open lawns, rustic backdrops, and natural water features — all perfect for capturing timeless pre-wedding memories."
    },
    {
      "name": "Nagpur Pre Wedding Shoot Location",
      "description": "If you’re searching for the perfect pre-wedding shoot location near Nagpur, Woodland Escape Resort provides a cinematic experience unlike any other. Its vast property offers endless creative possibilities — from sunrise fields to sunset views, each spot adds a romantic charm to your pictures. Professional photographers love the resort’s lighting and natural backdrops for dreamy photo sessions."
    },
    {
      "name": "Nagpur Romantic Shoot Spot",
      "description": "Woodland Escape Resort serves as a romantic shoot spot near Nagpur, where couples can express their love amidst breathtaking views. Whether it’s under flowering trees, near the riverside, or by cozy garden gazebos, every frame captures emotion and elegance. The resort’s peaceful atmosphere ensures couples can focus on creating beautiful, heartfelt moments together."
    },
    {
      "name": "Nagpur Outdoor Pre Wedding Spot",
      "description": "For couples who love nature, Woodland Escape Resort is an ideal outdoor pre-wedding spot near Nagpur. Surrounded by open greenery, scenic trails, and picturesque views, it offers diverse settings for photography and videography. The outdoor environment enhances creativity, ensuring every couple gets stunning natural shots that tell their unique story."
    },
    {
      "name": "Affordable Pre Wedding Spot Nagpur",
      "description": "Woodland Escape Resort is one of the most affordable pre-wedding shoot spots near Nagpur. It offers great value packages that include access to beautiful outdoor locations, changing areas, and professional assistance if required. Couples can enjoy luxury-level backdrops and privacy without stretching their budget, making it a preferred choice for cost-effective shoots."
    },
    {
      "name": "Nagpur Resort Pre Wedding Shoot",
      "description": "Experience a resort-style pre-wedding shoot at Woodland Escape Resort near Nagpur. With lush gardens, rustic farm backdrops, and modern architecture, it provides an exceptional setting for photo and video shoots. Couples can also book a one-day resort experience, combining relaxation with romantic photography sessions across the scenic property."
    },
    {
      "name": "Nagpur Scenic Pre Wedding Spot",
      "description": "If you want breathtaking scenery for your pre-wedding shoot near Nagpur, Woodland Escape Resort offers the perfect canvas. From gently rolling hills to tranquil water bodies, every corner of the resort provides a cinematic backdrop. The soft natural light and open vistas make it a dream location for romantic, storybook-style pre-wedding photos."
    },
    {
      "name": "Nagpur Garden Pre Wedding Location",
      "description": "Woodland Escape Resort’s vibrant garden areas make it one of the top garden pre-wedding locations near Nagpur. Couples can capture romantic moments amidst colorful blooms, landscaped lawns, and peaceful walkways. The garden setting offers an elegant yet natural atmosphere that enhances the beauty and emotion of every shot."
    },
    {
      "name": "Nagpur Riverside Shoot Spot",
      "description": "For couples dreaming of a riverside shoot near Nagpur, Woodland Escape Resort delivers an enchanting experience. The calm riverbanks, reflective waters, and soft golden light create a naturally romantic atmosphere. Whether you prefer traditional outfits or a modern theme, the riverside backdrop brings out stunning, cinematic frames."
    },
    {
      "name": "Nagpur Hill Pre Wedding Spot",
      "description": "Woodland Escape Resort is located near scenic hills that provide a stunning setting for pre-wedding photography. The elevated landscape, panoramic views, and tranquil vibes make it an ideal hill pre-wedding spot near Nagpur. Couples can take advantage of sunrise and sunset lighting for unforgettable romantic pictures."
    },
    {
      "name": "Nagpur Couple Shoot Destination",
      "description": "As a top couple shoot destination near Nagpur, Woodland Escape Resort offers versatility, comfort, and scenic beauty. The resort’s natural elements—gardens, water views, and rustic structures—allow photographers to craft unique visual stories. Whether casual, traditional, or cinematic, the location adapts beautifully to every theme."
    },
    {
      "name": "Nagpur Pre Wedding Tour",
      "description": "Make your pre-wedding experience a memorable journey with a one-day tour to Woodland Escape Resort near Nagpur. This exclusive package includes access to multiple scenic zones, refreshments, and a relaxed environment for a creative shoot. Couples can enjoy both the photography and the peaceful getaway atmosphere in one trip."
    },
    {
      "name": "Nagpur One Day Pre Wedding Shoot",
      "description": "Woodland Escape Resort offers the perfect one-day pre-wedding shoot package near Nagpur. Enjoy a full day of photography at various beautiful locations — from gardens to riverside areas and forest trails. The team ensures you have privacy, amenities, and ample time to create a full set of stunning pre-wedding images."
    },
    {
      "name": "Nagpur Pre Wedding Photography Location",
      "description": "Photographers and couples alike consider Woodland Escape Resort one of the best pre-wedding photography locations near Nagpur. The resort combines artistic settings with natural lighting, offering diverse frames for every mood. It’s the ideal place for capturing romantic stories with creative compositions in a serene setting."
    },
    {
      "name": "Nagpur Booking for Pre Wedding Shoot",
      "description": "Booking your pre-wedding shoot at Woodland Escape Resort near Nagpur is quick and easy. The resort offers flexible slots, private access areas, and complete support for photographers and couples. Whether it’s a sunrise shoot or a full-day session, the booking ensures a smooth, organized experience from start to finish."
    }
  ],
  "tableData": [
    ["- Pre Wedding Destination Near Nagpur", "- Nagpur Pre Wedding Shoot Location"],
    ["- Nagpur Romantic Shoot Spot", "- Nagpur Outdoor Pre Wedding Spot"],
    ["- Affordable Pre Wedding Spot Nagpur", "- Nagpur Resort Pre Wedding Shoot"],
    ["- Nagpur Scenic Pre Wedding Spot", "- Nagpur Garden Pre Wedding Location"],
    ["- Nagpur Riverside Shoot Spot", "- Nagpur Hill Pre Wedding Spot"],
    ["- Nagpur Couple Shoot Destination", "- Nagpur Pre Wedding Tour"],
    ["- Nagpur One Day Pre Wedding Shoot", "- Nagpur Pre Wedding Photography Location"],
    ["- Nagpur Booking for Pre Wedding Shoot", ""]
  ],
  


whychoose: [
  {
    "WhyChooseheading": "Romantic Pre-Wedding Destination Near Nagpur",
    "WhyChoosedescription": "Woodland Escape Resort is one of the most beautiful pre-wedding destinations near Nagpur, offering a perfect mix of natural beauty, privacy, and charm. Set amidst a peaceful forest, it provides stunning backdrops and a serene environment that make every pre-wedding moment truly magical and memorable."
  },
  {
    "WhyChooseheading": "Picturesque Forest Backdrops for Photoshoots",
    "WhyChoosedescription": "Capture your love story amidst the enchanting beauty of nature. Woodland Escape Resort features lush greenery, scenic forest trails, ponds, and natural light that make for breathtaking pre-wedding photographs. Every corner of the resort offers a unique frame that reflects romance and elegance."
  },
  {
    "WhyChooseheading": "Tranquil and Private Setting",
    "WhyChoosedescription": "Away from the city’s noise and distractions, Woodland Escape Resort offers a peaceful and private environment for couples to celebrate their journey together. Whether it’s a cozy photoshoot or an intimate pre-wedding event, the calm surroundings ensure a relaxed and romantic atmosphere."
  },
  {
    "WhyChooseheading": "Luxurious and Comfortable Stay Options",
    "WhyChoosedescription": "Our resort offers beautifully designed cottages and rooms that combine rustic forest charm with modern comfort. Couples can unwind after their shoot or event in cozy accommodations, surrounded by the soothing sounds of nature. It’s the perfect blend of comfort and elegance for your pre-wedding getaway."
  },
  {
    "WhyChooseheading": "Customizable Décor and Event Spaces",
    "WhyChoosedescription": "Woodland Escape Resort provides flexible event spaces and open forest venues that can be customized to suit your theme. Whether you prefer a boho outdoor setup, a floral forest vibe, or a minimalist nature theme, our team can bring your vision to life with elegant décor and creative arrangements."
  },
  {
    "WhyChooseheading": "Culinary Delights to Complement the Occasion",
    "WhyChoosedescription": "Savor delicious meals prepared from fresh, locally sourced ingredients. Our chefs curate special menus for couples and their guests, offering everything from light refreshments to full-course feasts. Every dish adds a flavorful touch to your pre-wedding celebration."
  },
  {
    "WhyChooseheading": "Easily Accessible from Nagpur",
    "WhyChoosedescription": "Located just a short scenic drive from Nagpur, Woodland Escape Resort is easily accessible yet tucked away in a peaceful forest. Its convenient location allows couples and photographers to plan their shoots or events effortlessly while enjoying a nature-filled escape close to the city."
  }
]






  
  



  }

const faqData = [
  {
    question: "Why is Woodland Escape Resort the best pre-wedding destination near Nagpur?",
    answer: "Woodland Escape Resort offers stunning natural landscapes, open green lawns, lakeside views, and cozy cottages — making it one of the best pre-wedding destinations near Nagpur. It’s a perfect blend of elegance, privacy, and natural beauty for your special moments."
  },
  {
    question: "How far is Woodland Escape Resort from Nagpur?",
    answer: "The resort is conveniently located about 45 km from Nagpur, which takes roughly 1 to 1.5 hours to reach by car. The short and scenic drive makes it a convenient yet exclusive getaway for pre-wedding celebrations and photoshoots."
  },
  {
    question: "What makes the resort ideal for pre-wedding photoshoots?",
    answer: "Our resort features picturesque backdrops such as lush gardens, lakesides, rustic cottages, and sunset viewpoints. Whether you want traditional elegance or cinematic vibes, every corner of the property is photo-worthy and perfect for capturing memories."
  },
  {
    question: "Do you offer packages for pre-wedding shoots and stays?",
    answer: "Yes! We offer customized pre-wedding packages that include venue access, accommodation, meals, and assistance with decor or props if required. Our team can tailor the experience based on your vision and theme."
  },
  {
    question: "Can we host small pre-wedding events at the resort?",
    answer: "Absolutely! Woodland Escape Resort is perfect for intimate gatherings like haldi, mehendi, and engagement celebrations. We provide complete event support including decoration, catering, and music arrangements."
  },
  {
    question: "How can we book Woodland Escape Resort for a pre-wedding shoot or event?",
    answer: "You can reach out to our event team via phone, WhatsApp, or through our official website. We recommend advance booking to ensure availability and allow our team to create a customized experience for your pre-wedding celebration."
  }
];

const testimonials = [
  {
    name: "Mr. Rohit & Miss. Sneha, Nagpur",
    text: "Our pre-wedding shoot at Woodland Escape Resort was absolutely magical! The natural scenery, peaceful environment, and beautiful lighting made our photos stunning. The staff was supportive and made sure everything went smoothly."
  },
  {
    name: "Miss. Aarti & Team, Nagpur",
    text: "We organized a pre-wedding function at Woodland Escape Resort, and it was a dream come true! The venue was decorated beautifully, and the surroundings added a perfect charm to our event. Highly recommended for couples near Nagpur!"
  }
];





      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "One Day Adventure Resorts Near Nagpur",
  "image": "https://woodlandescape.com/assets/images/one-day-adventure-resorts-near-nagpur.jpg",
  "description": "Experience the thrill at Woodlandescape Resort — one of the best one day adventure resorts near Nagpur. Enjoy outdoor games, ziplining, trekking, kayaking, and more at our fun-filled nature resort perfect for families and groups.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1652"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1499",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/one-day-adventure-resorts-near-nagpur"
  }
};



  return (
    <div>
<Helmet>
  <title>One Day Adventure Resorts Near Nagpur | Fun & Thrill Getaway | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Plan your next thrilling getaway at Woodlandescape Resort — one of the best one day adventure resorts near Nagpur. Enjoy adventure activities, nature fun, and relaxation in a perfect outdoor setting." 
  />
  <meta 
    name="keywords" 
    content="One Day Adventure Resorts Near Nagpur, Nagpur Adventure Day Trip, Nagpur Adventure Park, Nagpur One Day Fun Resort, Affordable Adventure Resort Nagpur, Nagpur Outdoor Adventure Spot, Nagpur Family Adventure Resort, Nagpur Weekend Adventure Trip, Nagpur Hill Adventure Resort, Nagpur River Adventure Spot, Nagpur Kids Adventure Resort, Nagpur Adventure Activity Center, Nagpur Short Adventure Trip, Nagpur Resort Adventure Booking, Nagpur One Day Excursion" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/7.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Onedayadventurersortnearnagpur;